import { Wrapper } from "./css/BigSideBarStyle";
import NavLinks from "./NavLinks";
import AppLogo from "./AppLogo";
import { useSelector } from "react-redux";

const BigSideBar = () => {
    const { isSideBarOpen } = useSelector((store) => store.auth);
    return (
        <Wrapper>
            <div className={isSideBarOpen ? "sidebar-container" : "sidebar-container show-sidebar"}>
                <div className="content">
                    <header>
                        <AppLogo
                            containerStyle="logo-container"
                            textStyle="app-logo-text"
                        />
                    </header>
                    <NavLinks/>
                </div>
            </div>
        </Wrapper>
    )
};
export default BigSideBar;